import { useEffect } from 'react';

const GTM_ID = 'GTM-KFH896Q3';
const GTM_SCRIPT_ID = 'gtm-head-script';

export function GtmScript() {
  useEffect(() => {
    if (document.getElementById(GTM_SCRIPT_ID)) return;

    const script = document.createElement('script');
    script.id = GTM_SCRIPT_ID;
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${GTM_ID}');`;
    document.head.insertBefore(script, document.head.firstChild);
  }, []);

  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
        title="Google Tag Manager"
      />
    </noscript>
  );
}
